// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"FindsIcon_iconWrapper__3ExS3","icon":"FindsIcon_icon__3sRUd","icon__units":"FindsIcon_icon__units__2N7mP","popper__text":"FindsIcon_popper__text__21A2F"};